(() => {
  'use strict';
  const site = document.querySelector('.cs-site');
  if (!site || site.dataset.csReady === 'true') return;
  site.dataset.csReady = 'true';

  let cartFeedbackTimer;
  document.addEventListener('shopify:cart:lines-update', async (event) => {
    try {
      const result = await event.promise;
      const count = result?.cart?.totalQuantity;
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('[data-cs-cart-count]').forEach((node) => { node.textContent = String(count); });
      document.querySelectorAll('[data-cs-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', link.dataset.csCartLabel + ' (' + count + ')');
      });
      const feedback = document.getElementById('cs-cart-feedback');
      if (!feedback) return;
      clearTimeout(cartFeedbackTimer);
      if (event.action === 'add' && !result.detail?.didError) {
        feedback.hidden = false;
        cartFeedbackTimer = setTimeout(() => { feedback.hidden = true; }, 5000);
      } else feedback.hidden = true;
    } catch (_) {}
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const motionButton = document.getElementById('cs-motion-toggle');
  const motionKey = 'cellular-station-motion';
  const tiltCards = [...site.querySelectorAll('[data-tilt]')];
  const tiltState = new WeakMap();
  let preference = true;
  let motionEnabled = false;
  let revealObserver = null;
  try { preference = localStorage.getItem(motionKey) !== 'off'; } catch (_) { /* Storage may be unavailable in a private browser. */ }

  const resetTilt = (card) => {
    const state = tiltState.get(card);
    if (state?.frame) cancelAnimationFrame(state.frame);
    if (state?.timer) clearTimeout(state.timer);
    if (state) { state.frame = 0; state.timer = 0; }
    card.classList.remove('cs-is-tilting', 'cs-touch-tilting');
    card.style.removeProperty('--cs-tilt-x');
    card.style.removeProperty('--cs-tilt-y');
    card.style.removeProperty('--cs-shine-x');
    card.style.removeProperty('--cs-shine-y');
  };

  const setUpReveals = () => {
    if (revealObserver) revealObserver.disconnect();
    const items = [...site.querySelectorAll('.cs-reveal')];
    if (!motionEnabled || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -20px 0px', threshold: 0.06 });
    items.forEach((item) => {
      if (item.classList.contains('is-visible')) return;
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) item.classList.add('is-visible');
      else {
        item.classList.add('cs-will-reveal');
        revealObserver.observe(item);
      }
    });
  };

  const applyMotion = () => {
    motionEnabled = preference && !reduceMotion.matches;
    site.classList.toggle('cs-motion-enabled', motionEnabled);
    site.classList.toggle('cs-motion-disabled', !motionEnabled);
    if (motionButton) {
      motionButton.setAttribute('aria-pressed', String(motionEnabled));
      motionButton.setAttribute('aria-label', motionEnabled ? motionButton.dataset.motionDisable : motionButton.dataset.motionEnable);
      motionButton.title = reduceMotion.matches ? motionButton.dataset.motionReduced : motionEnabled ? motionButton.dataset.motionDisable : motionButton.dataset.motionEnable;
      const status = motionButton.querySelector('[data-motion-status]');
      if (status) status.textContent = motionEnabled ? motionButton.dataset.motionOn : motionButton.dataset.motionOff;
    }
    if (!motionEnabled) tiltCards.forEach(resetTilt);
    setUpReveals();
  };

  motionButton?.addEventListener('click', () => {
    if (reduceMotion.matches) return;
    preference = !preference;
    try { localStorage.setItem(motionKey, preference ? 'on' : 'off'); } catch (_) { /* The preference still applies for this page. */ }
    applyMotion();
  });
  const onMediaChange = (query, handler) => {
    if (query.addEventListener) query.addEventListener('change', handler);
    else if (query.addListener) query.addListener(handler);
  };
  onMediaChange(reduceMotion, applyMotion);
  onMediaChange(finePointer, () => tiltCards.forEach(resetTilt));

  tiltCards.forEach((card) => {
    const state = { frame: 0, timer: 0, x: 0, y: 0, rect: null };
    tiltState.set(card, state);
    card.addEventListener('pointerenter', (event) => {
      if (!motionEnabled || !finePointer.matches || event.pointerType === 'touch') return;
      state.rect = card.getBoundingClientRect();
    }, { passive: true });
    card.addEventListener('pointermove', (event) => {
      if (!motionEnabled || !finePointer.matches || event.pointerType === 'touch') return;
      if (!state.rect) state.rect = card.getBoundingClientRect();
      state.x = event.clientX;
      state.y = event.clientY;
      if (state.frame) return;
      state.frame = requestAnimationFrame(() => {
        state.frame = 0;
        if (!motionEnabled || !state.rect) return;
        const { left, top, width, height } = state.rect;
        if (!width || !height) return;
        const x = Math.max(0, Math.min(1, (state.x - left) / width));
        const y = Math.max(0, Math.min(1, (state.y - top) / height));
        const range = card.classList.contains('cs-hero-media') ? 5 : 4;
        card.style.setProperty('--cs-tilt-x', `${((0.5 - y) * range).toFixed(2)}deg`);
        card.style.setProperty('--cs-tilt-y', `${((x - 0.5) * range).toFixed(2)}deg`);
        card.style.setProperty('--cs-shine-x', `${(x * 100).toFixed(1)}%`);
        card.style.setProperty('--cs-shine-y', `${(y * 100).toFixed(1)}%`);
        card.classList.add('cs-is-tilting');
      });
    }, { passive: true });
    ['pointerleave', 'pointercancel'].forEach((eventName) => card.addEventListener(eventName, () => {
      resetTilt(card);
      state.rect = null;
    }, { passive: true }));
    const touchButton = card.querySelector('[data-touch-tilt]');
    touchButton?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!motionEnabled) return;
      resetTilt(card);
      // Restart a short, deliberate movement only when the visitor requests it.
      requestAnimationFrame(() => {
        if (!motionEnabled) return;
        card.classList.add('cs-touch-tilting');
        state.timer = window.setTimeout(() => {
          card.classList.remove('cs-touch-tilting');
          state.timer = 0;
        }, 1200);
      });
    });
  });
  window.addEventListener('blur', () => tiltCards.forEach(resetTilt));
  document.addEventListener('visibilitychange', () => { if (document.hidden) tiltCards.forEach(resetTilt); });
  window.addEventListener('resize', () => tiltCards.forEach((card) => {
    resetTilt(card);
    const state = tiltState.get(card);
    if (state) state.rect = null;
  }), { passive: true });

  const menu = document.getElementById('cs-menu');
  const nav = site.querySelector('.cs-nav');
  const closeMenu = () => {
    nav?.classList.remove('is-open');
    menu?.setAttribute('aria-expanded', 'false');
  };
  if (menu && nav) {
    menu.setAttribute('aria-expanded', 'false');
    menu.addEventListener('click', () => {
      const expanded = menu.getAttribute('aria-expanded') !== 'true';
      nav.classList.toggle('is-open', expanded);
      menu.setAttribute('aria-expanded', String(expanded));
    });
    nav.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenu(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        menu.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target) && !menu.contains(event.target)) closeMenu();
    });
    onMediaChange(window.matchMedia('(max-width: 680px)'), closeMenu);
  }

  const dialog = document.getElementById('cs-video-dialog');
  const videoFrame = dialog?.querySelector('.cs-video-frame');
  const videoTitle = dialog?.querySelector('.cs-video-title');
  const videoFallback = document.getElementById('cs-video-fallback');
  let videoTrigger = null;
  if (dialog && videoFrame) {
    const clearVideo = () => {
      videoFrame.replaceChildren();
      document.documentElement.classList.remove('cs-video-open');
      document.body.classList.remove('cs-video-open');
      if (videoTrigger?.isConnected) videoTrigger.focus({ preventScroll: true });
      videoTrigger = null;
    };
    const closeVideo = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else { dialog.removeAttribute('open'); clearVideo(); }
    };
    site.querySelectorAll('[data-video]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.video;
        if (!id || !/^[\w-]{11}$/.test(id)) return;
        const title = button.dataset.videoTitle || button.closest('.cs-film')?.querySelector('h3')?.textContent || 'Film ufficiale';
        const url = `https://www.youtube.com/watch?v=${encodeURIComponent(id)}`;
        if (typeof dialog.showModal !== 'function') { window.open(url, '_blank', 'noopener,noreferrer'); return; }
        videoTrigger = button;
        if (videoTitle) videoTitle.textContent = title;
        if (videoFallback) {
          const link = videoFallback.matches('a') ? videoFallback : videoFallback.querySelector('a');
          if (link) { link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer'; }
        }
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
        iframe.title = title;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        videoFrame.replaceChildren(iframe);
        document.documentElement.classList.add('cs-video-open');
        document.body.classList.add('cs-video-open');
        dialog.showModal();
        dialog.querySelector('[data-close-video]')?.focus({ preventScroll: true });
      });
    });
    dialog.querySelectorAll('[data-close-video]').forEach((button) => button.addEventListener('click', closeVideo));
    dialog.addEventListener('close', clearVideo);
    dialog.addEventListener('cancel', () => { /* Native Escape closes the dialog and triggers cleanup. */ });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeVideo();
    });
  }

  applyMotion();
})();
